import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  tabWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  iconWrapper: {
    width: '28px',
    height: '28px',
    background: theme.palette.textBackground.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2.5),
    weight: 400,
    style: 'Regular',
    fontSize: '16px',
    color: theme.palette.labraText.primary,
    horizontalAlignment: 'center',
    verticalAlign: 'middle',
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '0%',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  spanWords: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  installmentField: {
    width: '238px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    verticalAlign: 'middle',
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
}))
